import BaseMesh from "./Base/BaseMesh";
import { vectorizeGenomicPosInd } from "../../helpers/vectorize";

function updateBufferUnary(buffAttr, { count, isAppend }) {
  const { step, buffer } = buffAttr;
  const { array } = buffer;
  const start = isAppend ? buffAttr.itemCount : 0;

  buffAttr.updateItemCount(count, isAppend);

  return (i, y1, y2) => {
    const base = (start + i) * step;
    array[base + 0] = y1;
    array[base + 1] = y2;
  };
}

function calcDefaultOffsets(uniforms, conf) {
  if (conf.offset) return;
  const { offset } = uniforms.getMeshConf();
  if (offset) {
    uniforms.setOffsetXMap(offset.map((x) => x + offset[0]));
    uniforms.setOffsetYMap(offset.map((x) => x + offset[1]));
  }
}

class LineMesh extends BaseMesh {
  constructor(uniforms, conf) {
    calcDefaultOffsets(uniforms, conf);
    const verticesPerItem = 2;
    const idxPattern = [0, 1];
    const idxPerItem = 2;
    const isLineSeq = true;
    super({
      uniforms,
      conf,
      verticesPerItem,
      idxPerItem,
      idxPattern,
      isLineSeq,
    });
  }

  updateX({ count, isAppend }) {
    const posXBuffer = this.attrs.posX;
    const { step, buffer } = posXBuffer;
    const { array } = buffer;
    const start = isAppend ? posXBuffer.itemCount : 0;
    posXBuffer.updateItemCount(count, isAppend);
    return (i, x0, x1) => {
      const base = (start + i) * step;
      vectorizeGenomicPosInd(array, base + 2 * 0, x0);
      vectorizeGenomicPosInd(array, base + 2 * 1, x1);
    };
  }

  updateRgba(args) {
    return updateBufferUnary(this.attrs.rgbaCode, args);
  }

  updateY(args) {
    return updateBufferUnary(this.attrs.posY, args);
  }

  updatePosYInd(args) {
    return updateBufferUnary(this.attrs.posYInd, args);
  }

  updateTextureCoordsInd(args) {
    return updateBufferUnary(this.attrs.textureCoordsInd, args);
  }
}

export default LineMesh;
